import React from 'react';
import { CHECKOUT_STEPS } from 'lib/billing';
import { ConfigureStep } from './Configure/ConfigureStep';
import { PaymentStep } from './Payment/PaymentStep';
import { useCheckoutStore } from './store';

export function CheckoutRouter() {
  const step = useCheckoutStore((s) => s.step);
  if (step === CHECKOUT_STEPS.payment) return <PaymentStep />;
  return <ConfigureStep />;
}
